import api, { ResponsePayloadWithData } from '../../../api';

export type PlatformType = 'Android' | 'iOS' | 'Web intern' | 'Web extern' | 'P intern';
type LinkedAppType = 'WordList' | 'digibook' | 'MediaLink';
type TargetAudience = 'student' | 'teacher';
type AppPublishingState = 'draft' | 'review' | 'preview' | 'published';

export type App = {
  id: string;
  name: string;
  appType: {
    id: string;
    name: string;
    isExercise: boolean;
    isDigibook: boolean;
    icon: {
      color: string;
      initials: string;
    };
  };
  moduleId: string;
  module: {
    niceName: string;
    bookType: string;
    cover: string;
    styling: {
      primaryColor: string;
    };
  };
  licenseProduct: string;
  platformType: PlatformType;
  platformUrl?: string;
  platformLinkType?: LinkedAppType;
  linkedApp?: {
    id: string;
    type: LinkedAppType;
    manualIncluded?: boolean;
    miniSiteUrl?: string;
  };
  moduleSpecific: boolean;
  ownedByPelckmans: boolean;
  allowedToOpenInNewTab: boolean;
  target: TargetAudience;
  releaseDate?: string;
  published: boolean;
  state: AppPublishingState;
  cover?: string;
};

export const getAppsForModule = async (moduleId: string, includeSubModules = true) => {
  const { data } = await api.get<ResponsePayloadWithData<App[]>>(
    `studio/modules/${moduleId}/apps?includeSubModules=${includeSubModules}`,
  );

  return data;
};

// Apps the user has no access to have no linkedApp (or platformUrl for old digibooks)
export function hasNoLicense(app: App) {
  return app.platformUrl === undefined && app.linkedApp === undefined;
}
